import { useState } from "react";
import { FaBuilding } from "react-icons/fa";
import Modal from "../../components/modal/modal";
import { toast } from "react-toastify";
import { createDepartment, updateDepartment } from "../services/departmentservice";
import { getDepartmentStatusLabel, getDepartmentStatusClass } from "../../constants/constants";

const DepartmentFormModal = ({ editingDept, onClose, onSaved }) => {
  const [deptName, setDeptName] = useState(editingDept?.name || "");
  const [description, setDescription] = useState(editingDept?.description || "");
  const [status, setStatus] = useState(editingDept?.is_active ?? true);

  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const name = deptName.trim();

    if (!name) {
      setFieldErrors({ name: "Department name is required" });
      setError("Please check the field errors below.");
      return;
    }

    try {
      setSaving(true);

      if (editingDept) {
        await updateDepartment(editingDept.id, { name, description, is_active: status });
        toast.success("Department updated successfully");
      } else {
        await createDepartment({ name, description, is_active: status });
        toast.success("Department added successfully");
      }

      onSaved();
    } catch (error) {
      console.error(error);
      const respData = error.response?.data;
      const backendErrors =
        respData?.errors ||
        (respData && typeof respData === "object" && !respData.message && !respData.detail ? respData : null);
      if (backendErrors && typeof backendErrors === "object") {
        const formatted = {};
        for (const key in backendErrors) {
          const val = backendErrors[key];
          formatted[key] = Array.isArray(val) ? val[0] : val;
        }
        setFieldErrors(formatted);
      }
      setError(
        error.response?.data?.message || error.response?.data?.detail || "Please check the field errors below."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title={editingDept ? "Edit Department" : "Add Department"} onClose={() => { if (!saving) onClose(); }}>
      {error && <div className="form-error">{error}</div>}

      <div className="employee-form">
        <div className="employee-form-scroll">
          <div className="form-section-card">
            <div className="section-title-premium">
              <FaBuilding /> Department Information
            </div>

            <div className="grid-1">
              <div>
                <input
                  className={fieldErrors.name ? "input-error" : ""}
                  placeholder="Department Name *"
                  value={deptName}
                  onChange={(e) => {
                    setDeptName(e.target.value);
                    if (fieldErrors.name) setFieldErrors({ ...fieldErrors, name: null });
                  }}
                />
                {fieldErrors.name && (
                  <div className="field-error">
                    {Array.isArray(fieldErrors.name) ? fieldErrors.name[0] : fieldErrors.name}
                  </div>
                )}
              </div>

              <div>
                <textarea
                  className={fieldErrors.description ? "input-error" : ""}
                  placeholder="Description"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    if (fieldErrors.description) setFieldErrors({ ...fieldErrors, description: null });
                  }}
                />
                {fieldErrors.description && (
                  <div className="field-error">
                    {Array.isArray(fieldErrors.description) ? fieldErrors.description[0] : fieldErrors.description}
                  </div>
                )}
              </div>

              <div className="status-toggle">
                <span className={`status-label ${getDepartmentStatusClass(status)}`}>
                  {getDepartmentStatusLabel(status)}
                </span>
                <div className={`toggle-switch ${status ? "active" : ""}`} onClick={() => setStatus(!status)}>
                  <div className="toggle-knob"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <div className="modal-actions">
          <button className="primary" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>

          <button className="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DepartmentFormModal;